import useToastStore from '@/components/toast-notification/useToastStore';

const initAxiosHttpCodeInterceptors = (axios) => {
  axios.interceptors.response.use(
    (response) => {
      if (response.data) {
        const { success, message } = response.data;
        if (success !== undefined) {
          if (message) {
            const toastStore = useToastStore();
            toastStore.showMessage({
              type: success ? 'success' : 'error',
              message,
            });
          }

          if (success === false) {
            return Promise.reject(response);
          }
        }
      }

      return response;
    },
    (error) => {
      let message = '';
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        message = '404 - Not Found';
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error', error.message);
      }

      if (message === '') {
        message = error.message;
      }

      const toastStore = useToastStore();
      toastStore.showMessage({
        type: 'error',
        message,
      });

      return Promise.reject(error);
    },
  );
};

export default initAxiosHttpCodeInterceptors;
